import {
    // Taxonomies
    GET_SCHOOLS_TYPES,
    GET_SCHOOLS_PROGRAMMES,
    GET_SCHOOLS_DEGREES,
    GET_SCHOOLS_CERTIFICATIONS,
    TAXONOMIES_LOADING,

    // Schools dropdown
    GET_SCHOOLS_DROPDOWN_REQUEST,
    GET_SCHOOLS_DROPDOWN_FAILURE,
    GET_SCHOOLS_DROPDOWN_SUCCESS,

    // Schools Google Maps
    GET_SCHOOLS_MAPS_REQUEST,
    GET_SCHOOLS_MAPS_FAILURE,
    GET_SCHOOLS_MAPS_SUCCESS,

    // Schools list
    GET_SCHOOLS_REQUEST,
    GET_SCHOOLS_FAILURE,
    GET_SCHOOLS_SUCCESS,
    SET_SCHOOLS_SEARCH_CRITERIA,
    RESET_SCHOOLS_SEARCH_CRITERIA,
    TOGGLE_DRAWER_MOBILE_FILTER_SEARCH,

    // School details
    GET_SCHOOL_REQUEST,
    GET_SCHOOL_FAILURE,
    GET_SCHOOL_SUCCESS,

    // Dashboard
    DASHBOARD_GET_SCHOOLS_AUTHOR,
    DASHBOARD_GET_SCHOOLS_LOADING,

    // UI
    UI_SET_SCHOOL_FOCUSED,
    UI_REMEMBER_SCROLL_POSITION_LISTING,
    UI_REMEMBER_PAGINATION_LISTING,
    UI_HAS_TRIGGER_SEARCH_FROM_SEARCHBAR
} from './types';

const initialState = {
    school: {},
    schoolLoading: false,
    schoolErrors: {},

    schoolsDropdown: [],
    schoolsDropdownLoading: false,
    schoolsDropdownErrors: {},

    schoolsMaps: [],
    schoolsMapsLoading: false,
    schoolsMapsErrors: {},

    schools: [],
    schoolsLoading: false,
    schoolsErrors: {},
    hasMore: false,
    totalFuture: '',
    currentPage: 1,
    newSearch: false, // Set to TRUE to reinitialize the search results (= fresh/new list)
    fakeLoadingTime: 0,
    search: {
        submitted: false,
        type: 0,
        programme: 0,
        degree: 0,
    },
    drawerMobileFilterSearchOpen: false,

    types: [],
    programmes: [],
    degrees: [],
    certifications: [],
    taxonomiesLoading: false,

    idSchoolFocused: 0,
    uiRememberScrollPositionListing: 0,
    uiRememberPaginationListing: 1,

    dashboardSchoolsAuthor: [],
    dashboardSchoolsLoading: false,
};

export default function (state = initialState, action) {
    switch (action.type) {
        // School details
        case GET_SCHOOL_REQUEST:
            return {
                ...state,
                schoolLoading: true
            };
        case GET_SCHOOL_FAILURE:
            return {
                ...state,
                school: {},
                schoolLoading: false,
                schoolErrors: action.payload,
            };
        case GET_SCHOOL_SUCCESS:
            return {
                ...state,
                school: action.payload,
                schoolLoading: false,
                schoolErrors: {},
                /*search: {
                    ...state.search,
                    submitted: true, // Keep search criteria when the user will go back to the schools list...
                },*/
            };

        // Schools list
        case GET_SCHOOLS_REQUEST:
            return {
                ...state,
                schoolsLoading: true,
            };
        case GET_SCHOOLS_FAILURE:
            return {
                ...state,
                schools: [],
                schoolsLoading: false,
                schoolsErrors: action.payload,
            };
        case GET_SCHOOLS_SUCCESS:
            const schools = (action.newSearch) ? action.payload.posts : [...state.schools, ...action.payload.posts];

            return {
                ...state,
                schools: schools,
                schoolsLoading: false,
                schoolsErrors: {},
                hasMore: action.payload.hasMore,
                totalFuture: (action.payload.hasOwnProperty('foundPosts')) ? action.payload.foundPosts : null,
                currentPage: action.page,
                /*search: {
                    ...action.search,
                    submitted: false,
                },*/
                fakeLoadingTime: action.fakeLoadingTime,
            };
        case SET_SCHOOLS_SEARCH_CRITERIA:
            const type = isNaN(parseInt(action.searchTaxonomyType, 10)) ? 0 : parseInt(action.searchTaxonomyType, 10);
            const programme = isNaN(parseInt(action.searchTaxonomyProgramme, 10)) ? 0 : parseInt(action.searchTaxonomyProgramme, 10);
            const degree = isNaN(parseInt(action.searchTaxonomyDegree, 10)) ? 0 : parseInt(action.searchTaxonomyDegree, 10);

            return {
                ...state,
                search: {
                    submitted: true,
                    type: type,
                    programme: programme,
                    degree: degree,
                },
            };
        case RESET_SCHOOLS_SEARCH_CRITERIA:
            return {
                ...state,
                search: {
                    submitted: false,
                    type: 0,
                    programme: 0,
                    degree: 0,
                },
            };
        case TOGGLE_DRAWER_MOBILE_FILTER_SEARCH:
            return {
                ...state,
                drawerMobileFilterSearchOpen: !state.drawerMobileFilterSearchOpen,
            };

        // Schools dropdown
        case GET_SCHOOLS_DROPDOWN_REQUEST:
            return {
                ...state,
                schoolsDropdownLoading: true,
            };
        case GET_SCHOOLS_DROPDOWN_FAILURE:
            return {
                ...state,
                schoolsDropdown: [],
                schoolsDropdownLoading: false,
                schoolsDropdownErrors: action.payload,
            };
        case GET_SCHOOLS_DROPDOWN_SUCCESS:
            return {
                ...state,
                schoolsDropdown: action.payload.posts,
                schoolsDropdownLoading: false,
                schoolsDropdownErrors: {},
            };

        // Schools Google Maps
        case GET_SCHOOLS_MAPS_REQUEST:
            return {
                ...state,
                schoolsMapsLoading: true,
            };
        case GET_SCHOOLS_MAPS_FAILURE:
            return {
                ...state,
                schoolsMaps: [],
                schoolsMapsLoading: false,
                schoolsMapsErrors: action.payload,
            };
        case GET_SCHOOLS_MAPS_SUCCESS:
            return {
                ...state,
                schoolsMaps: action.payload.posts,
                schoolsMapsLoading: false,
                schoolsMapsErrors: {},
            };

        // Taxonomies
        case TAXONOMIES_LOADING:
            return {
                ...state,
                taxonomiesLoading: true
            };
        case GET_SCHOOLS_TYPES:
            return {
                ...state,
                types: action.payload,
                taxonomiesLoading: false
            };
        case GET_SCHOOLS_PROGRAMMES:
            return {
                ...state,
                programmes: action.payload,
                taxonomiesLoading: false
            };
        case GET_SCHOOLS_DEGREES:
            return {
                ...state,
                degrees: action.payload,
                taxonomiesLoading: false
            };
        case GET_SCHOOLS_CERTIFICATIONS:
            return {
                ...state,
                certifications: action.payload,
                taxonomiesLoading: false
            };
            
        // Dashboard
        case DASHBOARD_GET_SCHOOLS_AUTHOR:
            const eventsAuthor = (action.newSearch) ? action.payload.posts : [...state.dashboardSchoolsAuthor, ...action.payload.posts];

            return {
                ...state,
                dashboardSchoolsAuthor: eventsAuthor,
                dashboardSchoolsLoading: false,
                hasMore: action.payload.hasMore,
                currentPage: action.page,
                fakeLoadingTime: action.fakeLoadingTime,
            };
        case DASHBOARD_GET_SCHOOLS_LOADING:
            return {
                ...state,
                dashboardSchoolsLoading: true
            };

        // UI
        case UI_SET_SCHOOL_FOCUSED:
            return {
                ...state,
                idSchoolFocused: action.payload
            };
        case UI_REMEMBER_SCROLL_POSITION_LISTING:
            return {
                ...state,
                uiRememberScrollPositionListing: action.payload
            };
        case UI_REMEMBER_PAGINATION_LISTING:
            return {
                ...state,
                uiRememberPaginationListing: action.payload
            };

        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/features/Schools/reducers.js